<template>
  <div class="login_app">
     <div class="">
          <signupApp></signupApp>
     </div>
  </div>
</template>

<script>
import signupApp from '@/components/login/signupApp.vue';
export default {
    name:'SignUp',
    components:{signupApp},
       mounted(){
         document.body.classList.add('loginPage');
    },
    destroyed(){
      document.body.classList.remove('loginPage');
    }
}
</script>